exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-save-block[data-v-51d22030]{position:-webkit-sticky;position:sticky;bottom:0;right:0;text-align:right;width:100%;background:hsla(0,0%,85.9%,.6509803921568628)}.custom-select[data-v-51d22030]{line-height:32px;height:50px;border-radius:1px}", ""]);

// exports
